module.exports = __webpack_public_path__ + "assets/favicons/mstile-310x150.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/mstile-310x150.png
// module id = altK
// module chunks = 1